(function() {
  var stickySelectSelector = '.zrx-sticky-atc-bar .zrx-sticky-atc-select';
  var syncingVariantPickers = false;
  var syncFrame = null;
  var layoutStateFrame = null;
  var productDataCache = null;
  var cookieBannerObserverStarted = false;

  function applyCookieBannerClickFix() {
    var styleId = 'sks-cookie-banner-layer-fix';
    var consentButtonSelector = [
      '#shopify-pc__banner__btn-accept',
      '#shopify-pc__banner__btn-decline',
      '.shopify-pc__banner__btn-accept',
      '.shopify-pc__banner__btn-decline'
    ].join(',');

    if (!document.getElementById(styleId) && document.head) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        '#shopify-pc__banner,',
        '#shopify-pc__banner__wrapper,',
        '#shopify-pc__banner__dialog,',
        '.shopify-pc__banner,',
        '.shopify-pc__banner__wrapper,',
        '.shopify-pc__banner__dialog{',
        'z-index:2147483000!important;',
        '}'
      ].join('');
      document.head.appendChild(style);
    }

    document.querySelectorAll(consentButtonSelector).forEach(function(button) {
      if (button.getAttribute('data-sks-cookie-safe-click') === 'true') {
        return;
      }

      button.setAttribute('data-sks-cookie-safe-click', 'true');
      button.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    });
  }

  function observeCookieBannerClickFix() {
    if (cookieBannerObserverStarted || typeof MutationObserver === 'undefined') return;
    cookieBannerObserverStarted = true;

    new MutationObserver(applyCookieBannerClickFix).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function normalizeOptionText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function escapeCssIdentifier(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getInputLabelElement(input) {
    if (!input) return null;

    var label = input.id ? document.querySelector('label[for="' + escapeCssIdentifier(input.id) + '"]') : null;
    if (!label && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
      label = input.nextElementSibling;
    }

    return label;
  }

  // What the option is called in the product data. It is what the app's own
  // select carries, so it is what the two sides have to be matched on — and it
  // is not always what the swatch shows any more: a one-size value is printed in
  // the shopper's language, so the swatch spells out "Taglia unica" where the
  // product says "T.U.". The theme leaves the original on the label for exactly
  // this.
  function getInputLabel(input) {
    if (!input) return '';

    var label = getInputLabelElement(input);
    if (!label) return input.value;

    var optionLabel = label.getAttribute('data-option-label');
    if (optionLabel) return optionLabel.replace(/\s+/g, ' ').trim();

    // The swatch carries the size and, under it, the remaining stock ("41" +
    // "1 disp."). Only the size identifies the option, so read that element when
    // it is there and fall back to the whole label for swatches without a count.
    var sizeElement = label.querySelector('.block-swatch__label');

    return (sizeElement || label).textContent.replace(/\s+/g, ' ').trim();
  }

  // What the swatch shows, which is what the sticky bar should show with it.
  function getInputDisplayLabel(input) {
    var label = getInputLabelElement(input);
    var sizeElement = label ? label.querySelector('.block-swatch__label') : null;

    if (sizeElement) return sizeElement.textContent.replace(/\s+/g, ' ').trim();

    return getInputLabel(input);
  }

  // The app draws its select from the raw product data, so a one-size value
  // reaches it untranslated. The words and the spellings to recognise both come
  // from the theme (snippets/one-size-label.liquid, by way of js-variables), so
  // the bar and the selector above it say the same thing.
  function toDisplaySize(value) {
    var text = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    if (!text) return text;

    var variables = window.themeVariables || {};
    var label = (variables.strings || {}).oneSize;
    var tokens = (variables.settings || {}).oneSizeValues;

    if (!label || !Array.isArray(tokens)) return text;

    // Normalised exactly as snippets/one-size-label.liquid does it, or the two
    // sides recognise different things: the dot is dropped, so "T.U." becomes
    // "tu", while the separators that stand in for a space become one.
    var normalized = text
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/[_\-\/]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    for (var index = 0; index < tokens.length; index += 1) {
      if (normalized === String(tokens[index] || '').trim()) return label;
    }

    return text;
  }

  function getInputCount(input) {
    var label = getInputLabelElement(input);
    var count = label ? label.querySelector('.block-swatch__count') : null;

    if (!count) return '';
    if (count.classList.contains('block-swatch__count--none')) return '';
    if (count.classList.contains('block-swatch__count--unknown')) return '';

    return count.textContent.replace(/\s+/g, ' ').trim();
  }

  // The option text gets the stock count appended to it, so every comparison
  // runs on the label the option was built with, kept on the element itself.
  function getStickyOptionBaseText(option) {
    if (!option) return '';

    if (!option.hasAttribute('data-sks-base-text')) {
      option.setAttribute('data-sks-base-text', String(option.text || '').replace(/\s+/g, ' ').trim());
    }

    return option.getAttribute('data-sks-base-text');
  }

  function getStickyOptionMap() {
    var optionMap = {};

    document.querySelectorAll(stickySelectSelector).forEach(function(select) {
      Array.prototype.forEach.call(select.options || [], function(option) {
        optionMap[normalizeOptionText(getStickyOptionBaseText(option))] = true;
        optionMap[normalizeOptionText(option.value)] = true;
      });
    });

    return optionMap;
  }

  // Everything the swatches say about a size, read off them rather than
  // recomputed: the two views can never disagree, the string is whatever the
  // theme rendered in the visitor's language, and the colour is the very one
  // painted on the swatch.
  function getSizeStock() {
    var stock = {};

    getMainSizeInputs().forEach(function(input) {
      var name = normalizeOptionText(getInputLabel(input));
      if (!name) return;

      var label = getInputLabelElement(input);
      var count = label ? label.querySelector('.block-swatch__count') : null;
      if (!count) return;

      var soldOut = count.classList.contains('block-swatch__count--none');
      var untracked = count.classList.contains('block-swatch__count--unknown');
      if (untracked) return;

      stock[name] = {
        soldOut: soldOut,
        text: soldOut ? '' : count.textContent.replace(/\s+/g, ' ').trim(),
        color: window.getComputedStyle ? window.getComputedStyle(count).color : ''
      };
    });

    return stock;
  }

  // Carry the per-size stock from the variant picker into the sticky bar's
  // select.
  function decorateStickyOptions() {
    var stock = getSizeStock();
    var counts = {};

    Object.keys(stock).forEach(function(name) {
      if (stock[name].text) counts[name] = stock[name].text;
    });

    document.querySelectorAll(stickySelectSelector).forEach(function(select) {
      Array.prototype.forEach.call(select.options || [], function(option) {
        var base = getStickyOptionBaseText(option);
        var count = counts[normalizeOptionText(base)];
        var shown = toDisplaySize(base);
        var text = count ? shown + ' \u00b7 ' + count : shown;

        if (option.text !== text) option.text = text;
      });
    });
  }

  function getMainSizeInputs() {
    var fieldsets = Array.prototype.slice.call(document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset'));
    var sizeFieldset = fieldsets.find(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      return /taglia|taglie|size|misura|numero/i.test(legend ? legend.textContent : '');
    });

    if (sizeFieldset) {
      return Array.prototype.slice.call(sizeFieldset.querySelectorAll('input[data-option-position]'));
    }

    var stickyOptions = getStickyOptionMap();
    var inputGroups = {};

    document.querySelectorAll('variant-picker input[data-option-position], .variant-picker input[data-option-position]').forEach(function(input) {
      if (input.closest('.zrx-sticky-atc-bar')) return;

      var groupName = input.name || input.getAttribute('data-option-position') || 'default';
      inputGroups[groupName] = inputGroups[groupName] || [];
      inputGroups[groupName].push(input);
    });

    var groups = Object.keys(inputGroups).map(function(key) {
      return inputGroups[key];
    });

    if (groups.length === 1) return groups[0];

    return groups.find(function(group) {
      return group.some(function(input) {
        return stickyOptions[normalizeOptionText(getInputLabel(input))];
      });
    }) || [];
  }

  function getMainSelectedSize() {
    var selectedInput = getMainSizeInputs().find(function(input) {
      return input.checked;
    });

    if (selectedInput) return getInputLabel(selectedInput);

    var variantScript = document.querySelector('variant-picker script[data-variant]');
    if (!variantScript) return '';

    try {
      var variant = JSON.parse(variantScript.textContent || '{}');
      return variant.option1 || variant.public_title || variant.title || '';
    } catch (error) {
      return '';
    }
  }

  function setStickySelect(size, shouldDispatchChange) {
    var normalizedSize = normalizeOptionText(size);
    if (!normalizedSize) return;

    document.querySelectorAll(stickySelectSelector).forEach(function(select) {
      var matchingOption = Array.prototype.find.call(select.options || [], function(option) {
        return normalizeOptionText(getStickyOptionBaseText(option)) === normalizedSize || normalizeOptionText(option.value) === normalizedSize;
      });

      if (!matchingOption) return;

      var changed = select.value !== matchingOption.value;
      select.value = matchingOption.value;
      matchingOption.selected = true;

      if (shouldDispatchChange && changed) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function setMainSize(size) {
    var normalizedSize = normalizeOptionText(size);
    if (!normalizedSize) return false;

    var targetInput = getMainSizeInputs().find(function(input) {
      return normalizeOptionText(getInputLabel(input)) === normalizedSize;
    });

    if (!targetInput || targetInput.disabled) return false;
    if (targetInput.checked) return true;

    targetInput.checked = true;
    targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  // The label comes from the theme's locale files through js-variables, so it
  // follows the visitor's language in every locale the theme carries rather
  // than the handful a table in here could keep up to date.
  function getBackInStockLabel() {
    var strings = (window.themeVariables && window.themeVariables.strings) || {};

    return strings.notifyWhenAvailable || 'Notify me when back in stock';
  }

  // The sticky bar gives this action exactly the width of the add to cart
  // button beside it, and the full sentence wraps to two lines in there, which
  // is the one way it cannot look like that button. It gets the short label.
  function getBackInStockStickyLabel() {
    var strings = (window.themeVariables && window.themeVariables.strings) || {};

    return strings.notifyShort || getBackInStockLabel();
  }

  // The back in stock action stands in for the add to cart button, so it takes
  // that button's own skin — type, colours, borders, padding and height —
  // measured off the rendered button rather than restated here, since those
  // values come from the sticky bar app and from the theme's button settings.
  // Only the type is taken from the add to cart button. Copying its colours as
  // well went wrong in both directions: the button that models them is hidden
  // exactly when this action appears, and the app paints its own background,
  // so a borrowed text colour landed on a background that was never measured —
  // black on black, a label that reads as deleted. The background stays the
  // app's, and the text colour is decided against it.
  var BUTTON_TYPE_PROPERTIES = [
    'font-family', 'font-size', 'font-weight', 'font-style',
    'letter-spacing', 'text-transform'
  ];

  var buttonTypeCache = {};

  // Unlike the colours, the type of a hidden button is worth having: font
  // family, size, weight, spacing and case resolve whether or not the element
  // is on screen, and on a sold-out size the add to cart is hidden from the
  // first paint — waiting for it to be visible left the action in the app's own
  // font, which is what stayed different.
  function readButtonType(source, cacheKey) {
    if (source && window.getComputedStyle) {
      var styles = window.getComputedStyle(source);
      var type = {};

      BUTTON_TYPE_PROPERTIES.forEach(function(property) {
        var value = styles.getPropertyValue(property);
        if (value) type[property] = value;
      });

      buttonTypeCache[cacheKey] = type;
    }

    return buttonTypeCache[cacheKey] || null;
  }

  // The background can sit on the button or on anything behind it, so it is
  // looked for up the tree; white text on a dark ground, the theme's ink on a
  // light one, and white when nothing opaque turns up, since the app's button
  // is dark.
  function getEffectiveBackground(element) {
    var node = element;

    while (node && node !== document.documentElement) {
      var background = window.getComputedStyle(node).backgroundColor;
      var parts = background && background.match(/[\d.]+/g);

      if (parts && parts.length >= 3 && (parts.length < 4 || parseFloat(parts[3]) > 0.1)) {
        return parts.map(Number);
      }

      node = node.parentElement;
    }

    return null;
  }

  function getReadableTextColor(element) {
    var background = getEffectiveBackground(element);
    if (!background) return '#ffffff';

    var luminance = (background[0] * 299 + background[1] * 587 + background[2] * 114) / 1000;

    return luminance > 150 ? 'rgb(var(--text-color, 28 28 28))' : '#ffffff';
  }

  function applyButtonType(type, target) {
    if (!target) return;

    if (type) {
      Object.keys(type).forEach(function(property) {
        target.style.setProperty(property, type[property], 'important');
      });
    }

    var color = getReadableTextColor(target);

    // -webkit-text-fill-color as well as color: where an app sets it, and they
    // do, it wins over colour on Safari and the label stays invisible.
    function paint(element) {
      element.style.setProperty('color', color, 'important');
      element.style.setProperty('-webkit-text-fill-color', color, 'important');
    }

    paint(target);

    // The label often sits in a child the app colours with a rule of its own,
    // and a stylesheet cannot be relied on to outrank it: set it on the element.
    target.querySelectorAll('*').forEach(paint);
  }

  // The sticky bar stands this action next to the size select, and the app
  // gives it a taller box of its own. Squeezed to the select's height, the row
  // reads as one control beside another rather than two mismatched blocks.
  function fitStickyBackInStockHeight(bar, message) {
    var select = bar.querySelector('.zrx-sticky-atc-select');
    if (!select || !message) return;

    var height = select.getBoundingClientRect().height;
    if (!height) return;

    message.style.setProperty('height', height + 'px', 'important');
    message.style.setProperty('min-height', height + 'px', 'important');
    message.style.setProperty('max-height', height + 'px', 'important');
    message.style.setProperty('padding-block', '0', 'important');
    message.style.setProperty('line-height', '1.15', 'important');
    message.style.setProperty('white-space', 'nowrap', 'important');
    message.style.setProperty('overflow', 'hidden', 'important');
  }

  var BACK_IN_STOCK_SELECTOR = '.zrx-sticky-atc-oos-message, [data-back-in-stock-button], .bis-widget-button, .restock-rocket-button';

  // The sticky bar app and the back in stock app each render this action their
  // own way, and a class list is a guess about markup neither of them promises.
  // What is known for certain is the sentence, because the label comes from the
  // theme: anything in the bar carrying it is the button, whatever it is called.
  // Innermost match wins, then the button or link around it, so the styling
  // lands on the box rather than on a wrapper that merely contains it.
  function findStickyBackInStockTargets(bar) {
    var targets = Array.prototype.slice.call(bar.querySelectorAll(BACK_IN_STOCK_SELECTOR));
    var wanted = [normalizeOptionText(getBackInStockLabel()), normalizeOptionText(getBackInStockStickyLabel())];

    bar.querySelectorAll('button, a, div, span, p').forEach(function(node) {
      var text = normalizeOptionText(node.textContent);
      if (wanted.indexOf(text) < 0) return;

      var childCarriesIt = Array.prototype.some.call(node.children, function(child) {
        return wanted.indexOf(normalizeOptionText(child.textContent)) >= 0;
      });
      if (childCarriesIt) return;

      var host = node.closest('button, a, [role="button"]') || node;
      if (bar.contains(host) && targets.indexOf(host) < 0) targets.push(host);
    });

    return targets;
  }

  // Identifying the button by class failed, and by label it can fail too if the
  // app writes its own copy. What does not change is where it sits: in the
  // sold-out state the action next to the size select, on the same row and to
  // its right, is this button — there is nothing else it could be, since the add
  // to cart is gone. Everything here is gated on that state.
  var OVERLAY_SKIN_PROPERTIES = [
    'font-family', 'font-size', 'font-weight', 'font-style', 'letter-spacing',
    'text-transform', 'color', 'background-color',
    'border-top-left-radius', 'border-top-right-radius',
    'border-bottom-left-radius', 'border-bottom-right-radius'
  ];

  var STICKY_BELL = '<svg class="sks-sticky-size__bell" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
    + 'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M18 8.5a6 6 0 1 0-12 0c0 5.2-2 6.7-2 6.7h16s-2-1.5-2-6.7"/>'
    + '<path d="M13.7 19a2 2 0 0 1-3.4 0"/></svg>';

  // A native select shows one line of plain text, so the size and its stock
  // cannot be stacked or coloured inside it. The select keeps doing its job —
  // it is what opens the picker, and its options still carry the count — while
  // this paints the closed state over it: the size on one line, the stock or a
  // bell under it, in the colour the swatch above uses. It sits on the select's
  // own background and leaves the arrow uncovered, so nothing depends on how
  // the app draws either.
  // The overlay and the chip are ours, and this script watches the bar they sit
  // in: every write to them is a mutation the observer below answers with a new
  // sync. So they are written only when what they show changes. Comparing with
  // innerHTML cannot tell: the browser serialises the markup its own way, and
  // the colour set on the count ends up in it, so the two never matched and the
  // bar was rewritten on every frame, for as long as the page stayed open.
  function setStickySizeMarkup(element, markup) {
    if (element.getAttribute('data-sks-markup') === markup) return;
    element.innerHTML = markup;
    element.setAttribute('data-sks-markup', markup);
  }

  // The count keeps the swatch's own green or amber. The bell does not: on a
  // greyed-out swatch that colour reads as "disabled", but here the size is
  // the one selected, and at 50% over the control it all but disappeared.
  function paintStickySizeCount(count, entry) {
    if (!count) return;
    var color = entry && entry.text && entry.color ? entry.color : '';
    if (count.getAttribute('data-sks-color') === color) return;
    count.setAttribute('data-sks-color', color);
    if (color) {
      count.style.setProperty('color', color, 'important');
    } else {
      count.style.removeProperty('color');
    }
  }

  function renderStickySizeOverlay() {
    var stock = getSizeStock();

    document.querySelectorAll(stickySelectSelector).forEach(function(select) {
      var host = select.closest('.zrx-sticky-atc-select-wrapper') || select.parentElement;
      if (!host) return;

      var overlay = host.querySelector('.sks-sticky-size');

      if (!overlay) {
        overlay = document.createElement('span');
        overlay.className = 'sks-sticky-size';
        overlay.setAttribute('aria-hidden', 'true');
        host.appendChild(overlay);
      }

      var option = select.options[select.selectedIndex];
      if (!option) return;

      var size = getStickyOptionBaseText(option);
      var entry = stock[normalizeOptionText(size)];
      var shownSize = toDisplaySize(size);
      var styles = window.getComputedStyle ? window.getComputedStyle(select) : null;

      if (styles) {
        OVERLAY_SKIN_PROPERTIES.forEach(function(property) {
          var value = styles.getPropertyValue(property);
          if (value) overlay.style.setProperty(property, value, 'important');
        });

        // Sit on the select's padding box, inside its borders: an overlay laid
        // out against the wrapper instead would paint over the border on
        // whichever side the wrapper is wider, which is what swallowed the
        // left edge of the control.
        var selectBox = select.getBoundingClientRect();
        var hostBox = host.getBoundingClientRect();
        var borderLeft = parseFloat(styles.borderLeftWidth) || 0;
        var borderRight = parseFloat(styles.borderRightWidth) || 0;
        var borderTop = parseFloat(styles.borderTopWidth) || 0;
        var borderBottom = parseFloat(styles.borderBottomWidth) || 0;
        var arrowWidth = Math.min(36, selectBox.width * 0.28);

        if (selectBox.width && selectBox.height) {
          overlay.style.left = (selectBox.left - hostBox.left + borderLeft) + 'px';
          overlay.style.top = (selectBox.top - hostBox.top + borderTop) + 'px';
          overlay.style.width = Math.max(0, selectBox.width - borderLeft - borderRight - arrowWidth) + 'px';
          overlay.style.height = Math.max(0, selectBox.height - borderTop - borderBottom) + 'px';
        }
      }

      var markup = '<span class="sks-sticky-size__label">' + shownSize + '</span>';

      if (entry && entry.soldOut) {
        markup += '<span class="sks-sticky-size__count">' + STICKY_BELL + '</span>';
      } else if (entry && entry.text) {
        markup += '<span class="sks-sticky-size__count">' + entry.text + '</span>';
      }

      setStickySizeMarkup(overlay, markup);

      paintStickySizeCount(overlay.querySelector('.sks-sticky-size__count'), entry);
    });
  }

  // With one size the app renders no select at all — there is nothing to choose
  // — so the overlay above has nothing to paint on and the bar loses the size
  // and its stock, which every other product shows. A product with one size
  // still has a size worth reading, and "3 disp." is worth reading most of all
  // on the one nobody can pick a different variant of.
  //
  // So where the app left the control out, put a plain box in its place: the
  // same two lines in the same colours, in the same column of the bar's grid.
  // It is not a control and does not pretend to be one — there is nothing to
  // open — so it takes no pointer events.
  function renderStickySingleSizeChip() {
    var stock = getSizeStock();
    var inputs = getMainSizeInputs();

    document.querySelectorAll('.zrx-sticky-atc-bar').forEach(function(bar) {
      var chip = bar.querySelector('.sks-sticky-size-chip');

      // The app drew its own select: the overlay owns this bar, not the chip.
      // The same goes for any product that really has sizes to choose between —
      // a missing select there is the app's business, and standing in for it
      // with one size would be a lie.
      if (bar.querySelector('.zrx-sticky-atc-select') || inputs.length !== 1) {
        if (chip) chip.remove();
        return;
      }

      var size = getInputLabel(inputs[0]);
      var shownSize = getInputDisplayLabel(inputs[0]);
      if (!size) {
        if (chip) chip.remove();
        return;
      }

      if (!chip) {
        chip = document.createElement('span');
        chip.className = 'sks-sticky-size-chip';
        chip.setAttribute('aria-hidden', 'true');

        // Into the variants slot when the app kept one, otherwise straight into
        // the grid: the wrapper is the grid, and the product form above it is
        // display:contents, so either way the chip lands in the same column.
        var host = bar.querySelector('.zrx-sticky-atc-product-variants')
          || bar.querySelector('.zrx-sticky-atc-content-wrapper')
          || bar;
        host.appendChild(chip);
      }

      var entry = stock[normalizeOptionText(size)];
      var markup = '<span class="sks-sticky-size__label">' + shownSize + '</span>';

      if (entry && entry.soldOut) {
        markup += '<span class="sks-sticky-size__count">' + STICKY_BELL + '</span>';
      } else if (entry && entry.text) {
        markup += '<span class="sks-sticky-size__count">' + entry.text + '</span>';
      }

      setStickySizeMarkup(chip, markup);

      paintStickySizeCount(chip.querySelector('.sks-sticky-size__count'), entry);
    });
  }

  // The discount, mirrored onto the sticky bar.
  //
  // Nothing is recomputed here and nothing is translated here: the percentage
  // and the sale line are cloned from what Liquid already rendered further up
  // the page, so the sticky bar says exactly what the price block says, in the
  // language the page was served in, with the same deadline. Where the theme
  // editor has not been given those blocks there is nothing to clone and no
  // strip appears.
  //
  // It is a band pinned above the bar rather than a row inside it. The bar's
  // internals belong to the app: adding a child to its grid means guessing at a
  // layout that can change under us, while a full-width band above it is ours
  // to size, and being ours it can be held to one line.
  function stickySaleSource() {
    var line = document.querySelector('.sale-line:not(.sks-sticky-sale .sale-line)');
    var badge = document.querySelector('.sale-badge');

    if (line && line.closest('.zrx-sticky-atc-bar')) line = null;
    if (badge && badge.closest('.zrx-sticky-atc-bar')) badge = null;

    return { line: line, badge: badge };
  }

  function stickySaleKey(source) {
    var line = source.line;
    var timer = line ? line.querySelector('.sale-line__timer') : null;
    var label = line ? line.querySelector('.sale-line__label') : null;

    return [
      source.badge ? source.badge.textContent.trim() : '',
      label ? label.textContent.trim() : '',
      timer ? timer.getAttribute('expires-at') || '' : '',
      line && line.classList.contains('sale-line--black-friday') ? 'bf' : ''
    ].join('|');
  }

  // The strip is fixed to the viewport, not parented to the bar, so its
  // vertical place has to be measured: its bottom edge goes on the bar's top
  // edge, and `getBoundingClientRect().top` is exactly that — the border-box
  // top, border included.
  //
  // When the bar is away — no bar on the page, or slid off while the real buy
  // buttons are on screen — the strip goes with it. Left behind it would sit at
  // the foot of the window announcing a countdown for nothing.
  function seatStickySaleStrip(strip) {
    var bar = document.querySelector('.zrx-sticky-atc-bar');

    if (!bar || !isStickyAtcVisible(bar)) {
      if (!strip.hidden) strip.hidden = true;
      markStickySaleStrip(false);
      publishStickyStackHeight(null);
      return;
    }

    var top = bar.getBoundingClientRect().top;
    var value = Math.max(0, Math.round(window.innerHeight - top)) + 'px';

    if (strip.style.bottom !== value) strip.style.bottom = value;
    if (strip.hidden) strip.hidden = false;

    markStickySaleStrip(true);
    publishStickyStackHeight(strip.getBoundingClientRect().top);
  }

  // How tall the whole pinned block is — bar plus strip — measured from the
  // bottom of the window, published for CSS to pin the floating buttons above.
  //
  // Those offsets used to be typed: 7.75rem on a phone, 6.25rem on a desktop,
  // each a guess at the bar's height plus a gap. A guess is fine until the
  // block changes height, and then the WhatsApp button and the newsletter
  // bubble sit on top of whatever moved — which is exactly what the sale strip
  // did to them. Measured, they cannot: the strip can grow a line in Greek, the
  // app can restyle its bar, and the buttons still land just above it.
  function publishStickyStackHeight(top) {
    var root = document.documentElement;

    if (top === null) {
      root.style.removeProperty('--sks-sticky-stack-height');
      return;
    }

    var value = Math.max(0, Math.round(window.innerHeight - top)) + 'px';
    if (root.style.getPropertyValue('--sks-sticky-stack-height') !== value) {
      root.style.setProperty('--sks-sticky-stack-height', value);
    }
  }

  // Says whether the strip is currently the top of the pinned block, so
  // layout/theme.liquid can stand the bar's own top rule and shadow down and
  // leave one edge for the two of them. A class rather than `:has()`: this is
  // measured state, and it is already being measured a few lines up.
  function markStickySaleStrip(showing) {
    document.documentElement.classList.toggle('sks-has-sticky-sale', Boolean(showing));
  }

  // The bar can be on the page with no sale on it, and then it is the whole of
  // the pinned block. Without this the buttons would fall back to the typed
  // offset on every product that is not discounted.
  function publishBarOnlyStackHeight() {
    if (document.querySelector('body > .sks-sticky-sale:not([hidden])')) return;

    markStickySaleStrip(false);
    var bar = document.querySelector('.zrx-sticky-atc-bar');
    publishStickyStackHeight(bar && isStickyAtcVisible(bar) ? bar.getBoundingClientRect().top : null);
  }

  function seatStickySaleStripSoon() {
    var strip = document.querySelector('body > .sks-sticky-sale');
    if (strip) seatStickySaleStrip(strip);
    else publishBarOnlyStackHeight();
  }

  // The bar does not jump into place, it slides, and a slide produces no
  // mutation and no scroll event of its own. A short burst of frames after
  // anything that could have started one keeps the strip on its edge for the
  // length of the animation instead of arriving at the end of it.
  var seatBurstUntil = 0;
  var seatBurstFrame = null;

  function burstSeatStickySaleStrip() {
    seatBurstUntil = Date.now() + 700;
    if (seatBurstFrame !== null) return;

    var step = function() {
      seatBurstFrame = null;
      seatStickySaleStripSoon();
      if (Date.now() < seatBurstUntil) {
        seatBurstFrame = window.requestAnimationFrame(step);
      }
    };

    seatBurstFrame = window.requestAnimationFrame(step);
  }

  function renderStickySaleStrip() {
    var source = stickySaleSource();
    var key = stickySaleKey(source);
    var strip = document.querySelector('body > .sks-sticky-sale');

    if (!source.badge && !source.line) {
      if (strip) strip.remove();
      publishBarOnlyStackHeight();
      return;
    }

    // Rebuilding on every pass would restart the countdown once a second.
    if (strip && strip.getAttribute('data-sale-key') === key) {
      seatStickySaleStrip(strip);
      return;
    }
    if (strip) strip.remove();

    strip = document.createElement('div');
    strip.className = 'sks-sticky-sale';
    strip.setAttribute('data-sale-key', key);
    strip.setAttribute('aria-hidden', 'true');
    strip.hidden = true;

    if (source.badge) {
      var badge = source.badge.cloneNode(true);
      badge.className = 'sks-sticky-sale__badge';
      badge.removeAttribute('style');
      strip.appendChild(badge);
    }

    if (source.line) {
      if (source.line.classList.contains('sale-line--black-friday')) {
        strip.classList.add('sks-sticky-sale--black-friday');
      }

      var label = source.line.querySelector('.sale-line__label');
      if (label) {
        var labelCopy = label.cloneNode(true);
        labelCopy.className = 'sks-sticky-sale__label';
        strip.appendChild(labelCopy);
      }

      var timer = source.line.querySelector('.sale-line__timer');
      if (timer) {
        // A cloned custom element is a fresh instance: it reads `expires-at`
        // and starts its own interval when it lands in the document.
        var timerCopy = timer.cloneNode(true);
        timerCopy.className = 'sale-line__timer sks-sticky-sale__timer';
        strip.appendChild(timerCopy);
      }
    }

    document.body.appendChild(strip);
    seatStickySaleStrip(strip);
    burstSeatStickySaleStrip();
  }

  // On a sold-out size the add to cart button is hidden — the theme's own
  // custom CSS hides disabled buttons, and the sticky bar app swaps its button
  // for the message — so reading its skin right then gives the styling of a
  // button nobody can see: that is how the label came out invisible against its
  // own background. The skin is therefore taken only while a button is on
  // screen, remembered per surface, and replayed when the moment comes.
  var buttonSkinCache = {};

  function readButtonSkin(source, cacheKey) {
    if (source && isElementVisible(source) && window.getComputedStyle) {
      var styles = window.getComputedStyle(source);
      var skin = {};

      BUTTON_SKIN_PROPERTIES.forEach(function(property) {
        var value = styles.getPropertyValue(property);
        if (value) skin[property] = value;
      });

      if (skin.color && skin.color === skin['background-color']) return buttonSkinCache[cacheKey] || null;

      buttonSkinCache[cacheKey] = skin;
    }

    return buttonSkinCache[cacheKey] || null;
  }

  function applyButtonSkin(skin, target) {
    if (!skin || !target) return;

    Object.keys(skin).forEach(function(property) {
      target.style.setProperty(property, skin[property], 'important');
    });
  }

  // Picking by position means the add to cart could be picked by mistake if the
  // sold-out reading ever went wrong, and relabelling that button would cost a
  // sale. Anything that submits a cart form, or reads like the add to cart, is
  // left alone whatever else says otherwise.
  function looksLikeAddToCart(element) {
    // Not element.type: a <button> with no type attribute reports "submit", so
    // reading the property would call every plain button an add to cart. What
    // marks one is the form it posts to, or the label it carries.
    if (element.closest('form[action*="/cart"]')) return true;
    if (element.getAttribute('type') === 'submit' && element.closest('form')) return true;

    var addToCart = document.querySelector('buy-buttons button[type="submit"], .buy-buttons button[type="submit"]');
    var label = addToCart ? normalizeOptionText(addToCart.textContent) : '';

    return Boolean(label) && normalizeOptionText(element.textContent) === label;
  }

  function findStickyActionElement(bar) {
    var select = bar.querySelector('.zrx-sticky-atc-select');
    if (!select) return null;

    var selectBox = select.getBoundingClientRect();
    if (!selectBox.width) return null;

    var best = null;
    var bestWidth = 0;

    bar.querySelectorAll('button, a, [role="button"], .zrx-sticky-atc-oos-message').forEach(function(element) {
      if (element.classList.contains('zrx-sticky-atc-main-button')) return;
      if (element.closest('.zrx-sticky-atc-select-wrapper')) return;
      if (looksLikeAddToCart(element)) return;
      if (!isElementVisible(element)) return;

      var box = element.getBoundingClientRect();
      if (box.bottom < selectBox.top || box.top > selectBox.bottom) return;
      if (box.left < selectBox.right - 4) return;

      if (box.width > bestWidth) {
        best = element;
        bestWidth = box.width;
      }
    });

    return best;
  }

  function parseColor(value) {
    var parts = String(value || '').match(/[\d.]+/g);
    if (!parts || parts.length < 3) return null;
    if (parts.length > 3 && parseFloat(parts[3]) < 0.1) return null;

    return parts.slice(0, 3).map(Number);
  }

  function luminance(rgb) {
    return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  }

  // Last line of defence, and the one that needs to know nothing about either
  // app: anything in the bar whose text is too close in tone to what it sits on
  // cannot be read, whatever it is called and whichever stylesheet put it there.
  // Text and background are measured, and only the unreadable ones are touched.
  function repairUnreadableText(bar) {
    bar.querySelectorAll('*').forEach(function(element) {
      if (element.closest('.sks-sticky-size')) return;
      if (element.closest('.sks-sticky-sale')) return;
      if (!element.textContent.replace(/\s+/g, ' ').trim()) return;
      if (!isElementVisible(element)) return;

      var styles = window.getComputedStyle(element);
      var text = parseColor(styles.webkitTextFillColor) || parseColor(styles.color);
      var background = getEffectiveBackground(element);
      if (!text || !background) return;
      if (Math.abs(luminance(text) - luminance(background)) > 70) return;

      var readable = luminance(background) > 150 ? 'rgb(var(--text-color, 28 28 28))' : '#ffffff';
      element.style.setProperty('color', readable, 'important');
      element.style.setProperty('-webkit-text-fill-color', readable, 'important');
    });
  }

  function matchBackInStockToAddToCart() {
    document.querySelectorAll('.zrx-sticky-atc-bar').forEach(function(bar) {
      var type = readButtonType(bar.querySelector('.zrx-sticky-atc-main-button'), 'sticky');

      // Whatever plays the part in here — the sticky bar app's own out-of-stock
      // message, or the back in stock app's button dropped into the bar — gets
      // the same treatment. Reaching only for the message left the app's button
      // untouched, in its own font, colour and full-length label.
      findStickyBackInStockTargets(bar).forEach(function(target) {
        if (target.textContent.replace(/\s+/g, ' ').trim() !== getBackInStockStickyLabel()) {
          target.textContent = getBackInStockStickyLabel();
        }

        applyButtonType(type, target);
        fitStickyBackInStockHeight(bar, target);
      });

      if (shouldShowBackInStockForSelectedVariant()) {
        var action = findStickyActionElement(bar);

        if (action) {
          if (normalizeOptionText(action.textContent) !== normalizeOptionText(getBackInStockStickyLabel())) {
            action.textContent = getBackInStockStickyLabel();
          }

          applyButtonType(type, action);
          fitStickyBackInStockHeight(bar, action);
        }
      }
    });

    var type = readButtonType(
      document.querySelector('buy-buttons button[type="submit"], .buy-buttons button[type="submit"]'),
      'page'
    );

    document.querySelectorAll(BACK_IN_STOCK_SELECTOR).forEach(function(button) {
      if (button.closest('.zrx-sticky-atc-bar')) return;
      applyButtonType(type, button);
    });
  }

  function isBackInStockEmbedActive() {
    return Boolean(
      window.SkiSisesBackInStockOpen ||
      document.querySelector('#BackInStockProductJson, script[src*="back-in-stock-widget.js"]')
    );
  }

  function isElementVisible(element) {
    if (!element || element.hasAttribute('hidden')) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return Boolean(rect && rect.width > 0 && rect.height > 0);
  }

  function isStickyAtcVisible(stickyAtc) {
    if (!isElementVisible(stickyAtc)) return false;

    if (stickyAtc.classList && stickyAtc.classList.contains('zrx-sticky-atc-show')) {
      return true;
    }

    var rect = stickyAtc.getBoundingClientRect();
    return rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      Math.abs(window.innerHeight - rect.bottom) < 12;
  }

  var stickyAtcWasVisible = null;

  function syncStickyAtcLayoutState() {
    var stickyAtc = document.querySelector('.zrx-sticky-atc-bar');
    var visible = isStickyAtcVisible(stickyAtc);
    document.documentElement.classList.toggle('sks-has-sticky-atc', visible);

    // The bar comes and goes on a transition. Catching the change here is the
    // only signal there is that one has started: it produces no scroll event of
    // its own, and by the time a mutation lands the slide is already underway.
    if (stickyAtcWasVisible !== visible) {
      stickyAtcWasVisible = visible;
      burstSeatStickySaleStrip();
    }
  }

  function getBackInStockProductData() {
    if (productDataCache) return productDataCache;

    var script = document.getElementById('BackInStockProductJson');
    if (!script) return null;

    try {
      productDataCache = JSON.parse(script.textContent || '{}');
      return productDataCache;
    } catch (error) {
      return null;
    }
  }

  function isVariantAvailable(variant) {
    if (!variant) return null;
    if (variant.available === true || variant.availableForSale === true) return true;
    if (variant.available === false || variant.availableForSale === false) return false;

    var quantity = Number(variant.inventoryQuantity || variant.inventory_quantity || variant.stockQuantity);
    return Number.isFinite(quantity) ? quantity > 0 : null;
  }

  function getVariantById(variantId) {
    var productData = getBackInStockProductData();
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    var id = String(variantId || '');
    if (!id) return null;

    return variants.find(function(variant) {
      return String(variant.id || '') === id;
    }) || null;
  }

  function getVariantIdFromPicker() {
    var script = document.querySelector('variant-picker script[data-variant], .variant-picker script[data-variant]');
    if (!script) return '';

    try {
      var variant = JSON.parse(script.textContent || '{}');
      return variant && variant.id ? String(variant.id) : '';
    } catch (error) {
      return '';
    }
  }

  function getVariantIdFromSelectedOptions() {
    var productData = getBackInStockProductData();
    var options = productData && Array.isArray(productData.options) ? productData.options : [];
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    if (!options.length || !variants.length) return '';

    var picker = Array.prototype.find.call(document.querySelectorAll('variant-picker, .variant-picker'), function(element) {
      return !element.closest('.zrx-sticky-atc-bar');
    });
    if (!picker) return '';

    var selectedValues = [];
    picker.querySelectorAll('input[data-option-position]:checked').forEach(function(input) {
      var optionIndex = Number(input.getAttribute('data-option-position')) - 1;
      if (!Number.isInteger(optionIndex) || optionIndex < 0) return;
      selectedValues[optionIndex] = normalizeOptionText(getInputLabel(input));
    });

    if (selectedValues.filter(Boolean).length < options.length) return '';

    var variant = variants.find(function(candidate) {
      var selectedOptions = candidate.selectedOptions || {};
      return options.every(function(optionName, index) {
        var selectedValue = selectedValues[index];
        var optionValues = Object.keys(selectedOptions).map(function(key) {
          return selectedOptions[key];
        });
        var variantValue = normalizeOptionText(selectedOptions[optionName] || optionValues[index]);
        return selectedValue && variantValue && selectedValue === variantValue;
      });
    });

    return variant ? String(variant.id || '') : '';
  }

  function getSelectedVariant() {
    var selectedVariantId = getVariantIdFromSelectedOptions() ||
      getVariantIdFromPicker() ||
      new URL(window.location.href).searchParams.get('variant') ||
      '';

    var variant = getVariantById(selectedVariantId);
    if (variant) return variant;

    var selectedSize = normalizeOptionText(getMainSelectedSize());
    var productData = getBackInStockProductData();
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    if (!selectedSize) return null;

    return variants.find(function(candidate) {
      var selectedOptions = candidate.selectedOptions || {};
      return Object.keys(selectedOptions).some(function(key) {
        return normalizeOptionText(selectedOptions[key]) === selectedSize;
      });
    }) || null;
  }

  function shouldShowBackInStockForSelectedVariant() {
    var variant = getSelectedVariant();
    var availability = isVariantAvailable(variant);

    if (availability === null) return true;
    return !availability;
  }

  function openBackInStockModal(event) {
    if (!isBackInStockEmbedActive()) return;
    if (!shouldShowBackInStockForSelectedVariant()) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    if (typeof window.SkiSisesBackInStockOpen === 'function') {
      window.SkiSisesBackInStockOpen();
      return;
    }

    document.dispatchEvent(new CustomEvent('back-in-stock:open', { bubbles: true }));

    var fallbackButton = document.querySelector('[data-back-in-stock-button-kind="main"], [data-back-in-stock-button-kind="main-legacy"], .restock-rocket-button');
    if (fallbackButton && (!event || fallbackButton !== event.currentTarget)) {
      fallbackButton.click();
    }
  }

  function prepareBackInStockStickyMessage(message) {
    if (!isBackInStockEmbedActive()) return;
    if (!message || message.dataset.sksBackInStockPrepared === 'true') return;
    message.dataset.sksBackInStockPrepared = 'true';
    message.dataset.backInStockButton = 'true';
    message.dataset.backInStockButtonKind = 'sticky-legacy';
    message.classList.add('bis-widget-button', 'bis-widget-button--legacy', 'bis-widget-button--sticky', 'bis-widget-button--zrx-sticky');
    message.setAttribute('role', 'button');
    message.setAttribute('tabindex', '0');
    message.textContent = getBackInStockStickyLabel();

    message.addEventListener('click', openBackInStockModal, true);
    message.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        openBackInStockModal(event);
      }
    }, true);
    message.addEventListener('mouseenter', function() {
      message.style.setProperty('background', '#4a4a4a', 'important');
    });
    message.addEventListener('mouseleave', function() {
      message.style.setProperty('background', '#202223', 'important');
    });
    message.addEventListener('focus', function() {
      message.style.setProperty('background', '#4a4a4a', 'important');
    });
    message.addEventListener('blur', function() {
      message.style.setProperty('background', '#202223', 'important');
    });
  }

  function patchStickyOutOfStockLayout() {
    if (!isBackInStockEmbedActive()) return;
    var shouldShowMessage = shouldShowBackInStockForSelectedVariant();

    document.querySelectorAll('.zrx-sticky-atc-bar .zrx-sticky-atc-oos-message').forEach(function(message) {
      prepareBackInStockStickyMessage(message);
      message.dataset.visible = shouldShowMessage ? 'true' : 'false';
      message.hidden = !shouldShowMessage;

      if (!shouldShowMessage) {
        message.setAttribute('aria-hidden', 'true');
        message.style.setProperty('display', 'none', 'important');
        return;
      }

      message.setAttribute('aria-hidden', 'false');
      message.style.setProperty('grid-area', 'action', 'important');
      message.style.setProperty('align-self', 'center', 'important');
      message.style.setProperty('justify-self', 'stretch', 'important');
      message.style.setProperty('display', 'inline-flex', 'important');
      message.style.setProperty('align-items', 'center', 'important');
      message.style.setProperty('justify-content', 'center', 'important');
      message.style.setProperty('background', message.matches(':hover, :focus-visible') ? '#4a4a4a' : '#202223', 'important');
      message.style.setProperty('color', '#ffffff', 'important');
      message.style.setProperty('cursor', 'pointer', 'important');
      message.style.setProperty('width', '100%', 'important');
      message.style.setProperty('min-width', '0', 'important');
      message.style.setProperty('min-height', window.matchMedia('(min-width: 700px)').matches ? '3.25rem' : '3rem', 'important');
      message.style.setProperty('margin', '0', 'important');
      message.style.setProperty('border', '0', 'important');
      message.style.setProperty('border-radius', '0', 'important');
      message.style.setProperty('box-sizing', 'border-box', 'important');
      message.style.setProperty('font-size', window.matchMedia('(min-width: 700px)').matches ? '1rem' : '0.95rem', 'important');
      message.style.setProperty('font-weight', '400', 'important');
      message.style.setProperty('letter-spacing', '0', 'important');
      message.style.setProperty('line-height', '1.2', 'important');
      message.style.setProperty('text-align', 'center', 'important');
    });
  }

  function hasStickyControls() {
    return Boolean(
      document.querySelector(stickySelectSelector + ', .zrx-sticky-atc-bar .zrx-sticky-atc-oos-message')
    );
  }

  function syncStickyFromMain() {
    if (syncingVariantPickers) return;
    syncStickyAtcLayoutState();
    // Before the guard: `hasStickyControls` asks whether the app drew a select
    // or an out-of-stock message, and on a one-size product it drew neither —
    // which is the very case the chip is for.
    renderStickySingleSizeChip();
    renderStickySaleStrip();
    if (!hasStickyControls()) return;

    syncingVariantPickers = true;

    // Whatever throws in here, the flag has to come back down: it is what stops
    // a sync from re-entering itself, and left raised it freezes every later
    // sync for the life of the page — the picker and the sticky bar quietly
    // stop talking to each other.
    try {
      decorateStickyOptions();
      setStickySelect(getMainSelectedSize(), true);
      patchStickyOutOfStockLayout();
      matchBackInStockToAddToCart();
      renderStickySizeOverlay();
      document.querySelectorAll('.zrx-sticky-atc-bar').forEach(repairUnreadableText);
      syncStickyAtcLayoutState();
    } finally {
      syncingVariantPickers = false;
    }
  }

  function queueStickySync() {
    if (syncFrame !== null) return;

    syncFrame = window.requestAnimationFrame(function() {
      syncFrame = null;
      syncStickyFromMain();
    });
  }

  function queueStickyLayoutStateSync() {
    if (layoutStateFrame !== null) return;

    layoutStateFrame = window.requestAnimationFrame(function() {
      layoutStateFrame = null;
      syncStickyAtcLayoutState();
      // Scroll and resize both land here, and both move the bar's top edge
      // under the strip. Same frame, same coalescing, no second listener.
      seatStickySaleStripSoon();
    });
  }

  function isRelevantMutation(mutation) {
    // Our own overlay and chip changing is the result of a sync, not a reason
    // for another one.
    if (mutation.target instanceof Element && mutation.target.closest('.sks-sticky-size, .sks-sticky-size-chip')) {
      return false;
    }

    if (mutation.type === 'attributes') {
      var target = mutation.target;
      if (!(target instanceof Element)) return false;

      return Boolean(
        target.matches('.zrx-sticky-atc-bar, .zrx-sticky-atc-oos-message, variant-picker, .variant-picker, product-sticky-bar, buy-buttons') ||
        target.closest('.zrx-sticky-atc-bar, variant-picker, .variant-picker, product-sticky-bar, buy-buttons')
      );
    }

    return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
      if (!(node instanceof Element)) return false;

      return (
        node.matches &&
        node.matches('.zrx-sticky-atc-bar, .zrx-sticky-atc-oos-message, variant-picker, .variant-picker, product-sticky-bar, buy-buttons')
      ) || (
        node.querySelector &&
        node.querySelector('.zrx-sticky-atc-bar, .zrx-sticky-atc-oos-message, variant-picker, .variant-picker, product-sticky-bar, buy-buttons')
      );
    });
  }

  document.addEventListener('change', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches(stickySelectSelector)) {
      if (syncingVariantPickers) return;

      syncingVariantPickers = true;
      setMainSize(target.options[target.selectedIndex] ? getStickyOptionBaseText(target.options[target.selectedIndex]) : target.value);
      syncingVariantPickers = false;
      queueStickySync();

      return;
    }

    if (target.matches('variant-picker input[data-option-position], .variant-picker input[data-option-position]') && !target.closest('.zrx-sticky-atc-bar')) {
      queueStickySync();
    }
  }, true);

  document.addEventListener('variant:change', queueStickySync, true);
  document.addEventListener('product:rerender', queueStickySync, true);
  document.addEventListener('DOMContentLoaded', applyCookieBannerClickFix);
  document.addEventListener('DOMContentLoaded', queueStickySync);
  observeCookieBannerClickFix();
  applyCookieBannerClickFix();
  window.addEventListener('resize', queueStickyLayoutStateSync);
  window.addEventListener('scroll', queueStickyLayoutStateSync, { passive: true });
  window.addEventListener('load', applyCookieBannerClickFix);
  window.addEventListener('load', queueStickySync);

  if (document.body && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(mutations) {
      if (mutations.some(isRelevantMutation)) {
        queueStickySync();
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  var attempts = 0;
  var startupSync = window.setInterval(function() {
    queueStickySync();
    attempts += 1;

    if (attempts >= 4) {
      window.clearInterval(startupSync);
    }
  }, 650);
}());
